export const JOB_TYPES_LIST = ['student_job', 'first_job', 'internship']
export const COMPANIES_WITH_TAGS = ['start_up', 'ng']
export const PUBLIC_COMPANY = 'public_sector'
export const ITEM_WITH_ANALYTICS_FILTER_LIST = ['student_job', 'first_job', 'internship', 'company']
export const JOBS_AND_COMPANIES_LIST = ITEM_WITH_ANALYTICS_FILTER_LIST
